import { useEffect, useState } from "react";

const POLL_INTERVAL_MS = 5 * 60 * 1000; // 5 minutes

const fetchRemoteVersion = async () => {
  const response = await fetch(`/version.json?t=${Date.now()}`, { cache: "no-store" });
  if (!response.ok) return null;
  const data = await response.json();
  return data?.version ?? null;
};

const useVersionCheck = () => {
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    let localVersion = null;

    const check = async () => {
      const remote = await fetchRemoteVersion().catch(() => null);
      if (!remote) return;

      if (localVersion === null) {
        localVersion = remote;
        return;
      }

      if (remote !== localVersion) {
        setUpdateAvailable(true);
      }
    };

    check();
    const id = setInterval(check, POLL_INTERVAL_MS);
    return () => clearInterval(id);
  }, []);

  return updateAvailable;
};

export default useVersionCheck;
